import { EventStatus } from './consultories/types'

export interface RootState {
  layout: string
  signoutOpen: boolean
}

//Type for badge colors
export enum BadgeType {
  RED,
  BLUE,
  GREEN,
  ORANGE
}

export interface BreadcrumbItem {
  to: string
  text: string
}

export enum ApiVersion {
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
  V4 = 'v4'
}

export enum HTTPCode {
  Success = 200,
  Created = 201,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  ServerError = 500
}

export enum Result {
  LOADING,
  SUCCESS,
  ERROR
}

export interface CalendarEvent {
  start: string
  end: string
  title: string
  icon: string
  content: string
  class: string
  moduleId: number
  scheduleId: number
  doctorId: number
  doctorName: string
  status: EventStatus
}
